import React, { Component } from 'react';
import { useRefJs } from 'core/api/useRefJs.js';
useRefJs.setConfig({ 'business_component/print/print/main/index': '../../../../business_component/print/print/main/index.js' });

let PrintOutput = useRefJs(["business_component/print/print/main/index"], function (Poc) {
    class PrintOutput extends Component {
        constructor(props) {
            super(props);

        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc.PrintOutput ref={forwardedRef} {...rest} /> 
        }
    }
    return React.forwardRef((props, ref) => {  
        return <PrintOutput {...props} forwardedRef={ref} />;  
    });
});
export default PrintOutput;
export { PrintOutput };